import { createFileRoute } from '@tanstack/react-router';
import { getTasksOptions } from '../../../../features/claim/tasks/queryOptions';
import { TasksList } from '../../../../features/claim/tasks/list';
import { validateSearch } from '../../../../utils/pagination';
import { mapInitialFilters } from './../../../../utils/filter/utils';

export const Route = createFileRoute(
  '/_authenticated/claims/$guid/_layout/tasks',
)({
  component: Page,
  loaderDeps: ({ search }) => search,
  loader: async ({
    context: { queryClient },
    deps: search,
    params: { guid },
  }) => {
    const searchWithDefaultFilters = search.filter
      ? search
      : { ...search, filter: ['status,in_review'] };
    return await queryClient.ensureQueryData(
      getTasksOptions(guid, mapInitialFilters(searchWithDefaultFilters)),
    );
  },
  validateSearch: validateSearch,
});

export function Page() {
  const data = Route.useLoaderData();

  return (
    <div className="content-grid">
      <div className="col-span-full">
        <TasksList tasks={data} />
      </div>
    </div>
  );
}
